import { AgeGroup, getAgeGroup } from '@repo/utils';

/**
 * Subject and verb for "... do not mean X or will develop <condition>".
 * Adults read "you have"; baby and child kits read "<first name> has".
 * Falls back to the adult phrasing when the name is missing, so the sentence
 * never renders "undefined has".
 */
export default function conditionSubject(
  ageAtSampling?: number | null,
  firstName?: string,
): string {
  if (getAgeGroup(ageAtSampling ?? 0) === AgeGroup.ADULT || !firstName) {
    return 'you have';
  }

  return `${firstName} has`;
}
